
const Constants = {
    // Language Codes
    LANGUAGES: {
        KANNADA: 'kannada',
        ENGLISH: 'english'
    },

    // Language Display Names
    LANGUAGE_NAMES: {
        kannada: 'Kannada',
        english: 'English'
    },

    // Language Code to Short Code Mapping (for translation document structure)
    LANGUAGE_SHORT_CODES: {
        kannada: 'kn',
        english: 'en'
    },

    // Translation Collection Mapping
    TRANSLATION_COLLECTIONS: {
        'kannada-english': 'kannadaToEnglishTranslations',
        'english-kannada': 'englishToKannadaTranslations'
    },

    // Subject Options
    SUBJECT_OPTIONS: [
        { value: 'KANNADA', label: 'Kannada' }
    ],

    // Chapter Type Options
    CHAPTER_TYPE_OPTIONS: [
        { value: 'LESSON', label: 'Lesson' },
        { value: 'POEM', label: 'Poem' },
        { value: 'CREATIVE_WRITING', label: 'Creative Writing' },
        { value: 'NUMBERS', label: 'Numbers' },
        { value: 'GRAMMAR', label: 'Grammar' },
        { value: 'LETTER', label: 'Letter' }
    ],

    // Activity Types
    ACTIVITY_TYPES: {
        READ_CHAPTER: 'READ_CHAPTER',
        WORD_MEANING: 'WORD_MEANING',
        DUAL_MEANING: 'DUAL_MEANING',
        MATCH: 'MATCH',
        OPPOSITES: 'OPPOSITES',
        WHO_SAID_TO_WHOM: 'WHO_SAID_TO_WHOM',
        QUESTION_ANSWERS: 'QUESTION_ANSWERS',
        LONG_QUESTION_ANSWERS: 'LONG_QUESTION_ANSWERS',
        WORD_PRACTICE: 'WORD_PRACTICE',
        WORD_SPLIT: 'WORD_SPLIT',
        CREATIVE_WRITING: 'CREATIVE_WRITING',
        FILL_IN_BLANK_MCQ: 'FILL_IN_BLANK_MCQ',
        NUMBERS: 'NUMBERS',
        GENDERS: 'GENDERS',
        CHANGE_GENDERS: 'CHANGE_GENDERS',
        TENSES: 'TENSES',
        SINGULAR_PLURAL: 'SINGULAR_PLURAL',
        MAKE_SENTENCES: 'MAKE_SENTENCES',
        JOIN_WORDS: 'JOIN_WORDS',
        FILL_IN_THE_BLANKS_PARAGRAPH: 'FILL_IN_THE_BLANKS_PARAGRAPH'
    },

    // Activity Type Labels
    ACTIVITY_TYPE_LABELS: {
        READ_CHAPTER: 'Read Chapter',
        WORD_MEANING: 'Word Meaning',
        DUAL_MEANING: 'Dual Meaning',
        MATCH: 'Match the Following',
        OPPOSITES: 'Opposites',
        WHO_SAID_TO_WHOM: 'Who Said To Whom',
        QUESTION_ANSWERS: 'Question Answers',
        LONG_QUESTION_ANSWERS: 'Long Question Answers',
        WORD_PRACTICE: 'Word Practice',
        WORD_SPLIT: 'Word Split',
        CREATIVE_WRITING: 'Creative Writing',
        FILL_IN_BLANK_MCQ: 'Fill in the Blanks (MCQ)',
        NUMBERS: 'Numbers',
        GENDERS: 'Genders',
        CHANGE_GENDERS: 'Change Genders',
        TENSES: 'Tenses',
        SINGULAR_PLURAL: 'Singular / Plural',
        MAKE_SENTENCES: 'Make Sentences',
        JOIN_WORDS: 'Join Words',
        FILL_IN_THE_BLANKS_PARAGRAPH: 'Fill in the Blanks (Paragraph)'
    },

    // Activity Type UI Configuration
    ACTIVITY_TYPE_CONFIG: {
        READ_CHAPTER: {
            title: "📖 Read Chapter",
            color: "linear-gradient(135deg, #2d5016 0%, #0f3460 100%)",
            icon: "📖",
            hoverColor: "#1e3a8a",
            isReadChapter: true
        },
        WORD_MEANING: {
            title: "📚 Word Meanings",
            color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
            icon: "📚",
            hoverColor: "#38a169"
        },
        DUAL_MEANING: {
            title: "🧩 Dual Meaning",
            color: "linear-gradient(135deg, #f97316 0%, #facc15 100%)",
            icon: "🧩",
            hoverColor: "#f59e0b"
        },
        MATCH: {
            title: "🔗 Match the Following",
            color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
            icon: "🔗",
            hoverColor: "#3182ce"
        },
        OPPOSITES: {
            title: "🔄 Opposites",
            color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
            icon: "🔄",
            hoverColor: "#d69e2e"
        },
        WHO_SAID_TO_WHOM: {
            title: "💬 Who Said To Whom",
            color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
            icon: "💬",
            hoverColor: "#38b2ac"
        },
        QUESTION_ANSWERS: {
            title: '🇶 Question Answers',
            color: 'linear-gradient(135deg, #8E2DE2 0%, #4A00E0 100%)',
            icon: '🇶',
            isReadChapter: false,
            hasLevels: true,
            levels: [
                { id: 1, title: 'Learning Mode', description: 'Study question and answers' },
                { id: 2, title: 'Word Selection', description: 'Build answers using words' },
                { id: 3, title: 'Letter Arrangement', description: 'Arrange letters and practice spellings' }
            ]
        },
        LONG_QUESTION_ANSWERS: {
            title: '📝 Long Question Answers',
            color: 'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)',
            icon: '📝',
            isReadChapter: false,
            hasLevels: false
        },
        WORD_PRACTICE: {
            title: "✍️ Word Practice",
            color: "linear-gradient(135deg, #ff9a56 0%, #ff6a88 100%)",
            icon: "✍️",
            hoverColor: "#f97316"
        },
        WORD_SPLIT: {
            title: "🪓 Word Split",
            color: "linear-gradient(135deg, #22c55e 0%, #14b8a6 100%)",
            icon: "🪓",
            hoverColor: "#0f766e"
        },
        CREATIVE_WRITING: {
            title: "📝 Creative Writing",
            color: "linear-gradient(135deg, #a78bfa 0%, #ec4899 100%)",
            icon: "📝",
            hoverColor: "#9333ea"
        },
        FILL_IN_BLANK_MCQ: {
            title: "🧠 Fill in the Blanks",
            color: "linear-gradient(135deg, #34d399 0%, #22c55e 100%)",
            icon: "🧠",
            hoverColor: "#16a34a",
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study the sentences and answers',
                    icon: '📚',
                    component: 'fillInBlank/FillInBlankLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Multiple Choice',
                    description: 'Choose the correct word for the blank',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'FILL_IN_BLANK_MCQ'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters to form the correct answer',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'FILL_IN_BLANK_MCQ'
                    }
                }
            ]
        },
        NUMBERS: {
            title: "🔢 Numbers",
            color: "linear-gradient(135deg, #60a5fa 0%, #22c55e 100%)",
            icon: "🔢",
            hoverColor: "#2563eb"
        },
        JOIN_WORDS: {
            title: "🔗 Join Words",
            color: "linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)",
            icon: "🔗",
            hoverColor: "#7c3aed"
        },
        GENDERS: {
            title: "⚧ Genders",
            color: "linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)",
            icon: "⚧",
            hoverColor: "#db2777"
        },
        CHANGE_GENDERS: {
            title: "⚧ Change Genders",
            color: "linear-gradient(135deg, #f97316 0%, #8b5cf6 100%)",
            icon: "⚧",
            hoverColor: "#f97316"
        },
        SINGULAR_PLURAL: {
            title: "🔁 Singular / Plural",
            color: "linear-gradient(135deg, #f97316 0%, #facc15 100%)",
            icon: "🔁",
            hoverColor: "#f97316"
        },
        TENSES: {
            title: "⏰ Tenses",
            color: "linear-gradient(135deg, #38bdf8 0%, #6366f1 100%)",
            icon: "⏰",
            hoverColor: "#2563eb"
        },
        MAKE_SENTENCES: {
            title: "✏️ Make Sentences",
            color: "linear-gradient(135deg, #f97316 0%, #ec4899 100%)",
            icon: "✏️",
            hoverColor: "#f97316"
        }
    },

    // Difficulty Levels
    DIFFICULTY_LEVELS: {
        LEARNING: 'Learning',
        EASY: 'Easy',
        MEDIUM: 'Medium',
        HARD: 'Hard'
    },

    // Scope Levels
    SCOPE_LEVELS: {
        GLOBAL: 'GLOBAL',
        SCHOOL: 'SCHOOL',
        SECTION: 'SECTION',
        STUDENT: 'STUDENT'
    },

    // Grade Levels
    GRADE_LEVELS: [
        { value: 1, label: 'Grade 1' },
        { value: 2, label: 'Grade 2' },
        { value: 3, label: 'Grade 3' },
        { value: 4, label: 'Grade 4' },
        { value: 5, label: 'Grade 5' },
        { value: 6, label: 'Grade 6' },
        { value: 7, label: 'Grade 7' },
        { value: 8, label: 'Grade 8' },
        { value: 9, label: 'Grade 9' },
        { value: 10, label: 'Grade 10' }
    ],

    // Default Activity Content Templates
    DEFAULT_CONTENT: {
        WORD_MEANING: {
            words: [{
                languageWord: '',
                languageMeaning: '',
                englishMeaning: '',
                languageWordAudio: null,
                languageMeaningAudio: null,
                englishMeaningAudio: null,
                image: null
            }]
        },
        DUAL_MEANING: {
            words: [{
                languageWord: '',
                meaning1: '',
                meaning2: '',
                englishMeaning: '',
                languageWordAudio: null,
                meaning1Audio: null,
                meaning2Audio: null,
                englishMeaningAudio: null,
                confusingLetters1: [],
                confusingLetters2: [],
                image: null
            }]
        },
        MATCH: {
            wordPairs: [{
                id: 1,
                keyWord: '',
                valueWord: ''
            }]
        },
        OPPOSITES: {
            words: [{ word: '', opposite: '', difficulty: 'easy' }],
            settings: { maxAttempts: 3, showHints: true }
        },
        WHO_SAID_TO_WHOM: {
            dialogues: [{
                languageText: '',
                englishText: '',
                languageTextAudio: null,
                englishTextAudio: null,
                whoSaid: '',
                toWhom: '',
                whoSaidEnglish: '',
                toWhomEnglish: '',
                whoConfusingLetters: '',
                whomConfusingLetters: ''
            }]
        },
        QUESTION_ANSWERS: {
            questions: [{
                questionLanguage: '',
                questionEnglish: '',
                answerLanguage: '',
                answerEnglish: '',
                questionLanguageAudio: null,
                questionEnglishAudio: null,
                answerLanguageAudio: null,
                answerEnglishAudio: null,
                image: null
            }]
        },
        LONG_QUESTION_ANSWERS: {
            questions: [{
                questionLanguage: '',
                questionEnglish: '',
                answerLanguage: '',
                answerEnglish: '',
                questionLanguageAudio: null,
                questionEnglishAudio: null,
                answerLanguageAudio: null,
                answerEnglishAudio: null,
                image: null,
                keywords: '',
                keyConfusingLetters: ''
            }]
        },
        WORD_PRACTICE: {
            words: [{
                languageWord: '',
                englishWord: '',
                confusingLetters: '',
                languageAudio: null,
                englishAudio: null,
                image: null
            }]
        },
        WORD_SPLIT: {
            words: [{
                question: '',
                leftWord: '',
                rightWord: '',
                questionMeaning: '',
                answerMeaning: '',
                confusingLetters: '',
                languageAudio: null,
                englishAudio: null,
                image: null
            }]
        },
        JOIN_WORDS: {
            words: [{
                leftWord: '',
                rightWord: '',
                answer: '',
                answerMeaning: '',
                confusingLetters: '',
                leftWordAudio: null,
                rightWordAudio: null,
                answerAudio: null,
                image: null
            }]
        },
        TENSES: {
            groups: [{
                image: null,
                sentences: [
                    {
                        languageText: '',
                        englishText: '',
                        tenseEnglish: '',
                        tenseKannada: '',
                        languageAudio: null,
                        englishAudio: null
                    },
                    {
                        languageText: '',
                        englishText: '',
                        tenseEnglish: '',
                        tenseKannada: '',
                        languageAudio: null,
                        englishAudio: null
                    },
                    {
                        languageText: '',
                        englishText: '',
                        tenseEnglish: '',
                        tenseKannada: '',
                        languageAudio: null,
                        englishAudio: null
                    }
                ]
            }]
        },
        CREATIVE_WRITING: {
            prompts: [{
                title: '',
                description: '',
                image: null,
                keywords: [],
                minWords: 50,
                maxWords: 200,
                rubric: {
                    creativity: 25,
                    grammar: 25,
                    vocabulary: 25,
                    relevance: 25
                }
            }]
        },
        FILL_IN_BLANK_MCQ: {
            items: [{
                sentence: '', // Use ______ to mark the blank in the sentence
                options: ['', '', '', ''],
                correctOption: ''
            }]
        },
        NUMBERS: {
            fromNumber: 1,
            toNumber: 10,
            numbers: [{
                index: 1,
                englishNumber: '1',
                englishWordNumber: '',
                languageNumber: '',
                languageWordNumber: '',
                englishNumberAudio: null,
                languageNumberAudio: null,
                languageWordNumberAudio: null
            }]
        },
        GENDERS: {
            words: [{
                word: '',
                englishWord: '',
                genderEnglish: '',
                genderKannada: '',
                languageAudio: null,
                englishAudio: null,
                image: null
            }]
        },
        CHANGE_GENDERS: {
            pairs: [{
                maleLanguageWord: '',
                maleEnglishWord: '',
                femaleLanguageWord: '',
                femaleEnglishWord: '',
                maleImage: null,
                femaleImage: null,
                maleConfusingLetters: '',
                femaleConfusingLetters: '',
                maleLanguageAudio: null,
                maleEnglishAudio: null,
                femaleLanguageAudio: null,
                femaleEnglishAudio: null
            }]
        },
        SINGULAR_PLURAL: {
            words: [{
                singularWord: '',
                pluralWord: '',
                singularEnglish: '',
                pluralEnglish: '',
                singularAudio: null,
                pluralAudio: null,
                singularImage: null,
                pluralImage: null,
                singularEnglishAudio: null,
                pluralEnglishAudio: null
            }]
        },
        MAKE_SENTENCES: {
            sentences: [{
                languageWord: '',
                englishWord: '',
                languageSentence: '',
                englishSentence: '',
                languageWordAudio: null,
                englishWordAudio: null,
                languageSentenceAudio: null,
                englishSentenceAudio: null,
                image: null
            }],
            keywords: [{
                languageText: '',
                languageAudio: null,
                englishText: '',
                englishAudio: null,
                confusingLetters: ''
            }]
        }
    },

    // Tailwind CSS Classes
    BUTTON_CLASSES: {
        PRIMARY: 'bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        SECONDARY: 'bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        SUCCESS: 'bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        DANGER: 'bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        WARNING: 'bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        INFO: 'bg-cyan-600 hover:bg-cyan-700 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        LIGHT: 'bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg transition-colors border border-gray-300',
        DARK: 'bg-gray-800 hover:bg-gray-900 text-white font-medium py-2 px-4 rounded-lg transition-colors',
        OUTLINE_PRIMARY: 'border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-medium py-2 px-4 rounded-lg transition-colors',
        OUTLINE_SECONDARY: 'border border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white font-medium py-2 px-4 rounded-lg transition-colors',
        OUTLINE_SUCCESS: 'border border-green-600 text-green-600 hover:bg-green-600 hover:text-white font-medium py-2 px-4 rounded-lg transition-colors',
        OUTLINE_DANGER: 'border border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-medium py-2 px-4 rounded-lg transition-colors'
    },

    // Alert Classes
    ALERT_CLASSES: {
        PRIMARY: 'bg-blue-50 border border-blue-200 text-blue-800 p-4 rounded-lg',
        SECONDARY: 'bg-gray-50 border border-gray-200 text-gray-800 p-4 rounded-lg',
        SUCCESS: 'bg-green-50 border border-green-200 text-green-800 p-4 rounded-lg',
        DANGER: 'bg-red-50 border border-red-200 text-red-800 p-4 rounded-lg',
        WARNING: 'bg-yellow-50 border border-yellow-200 text-yellow-800 p-4 rounded-lg',
        INFO: 'bg-cyan-50 border border-cyan-200 text-cyan-800 p-4 rounded-lg',
        LIGHT: 'bg-gray-50 border border-gray-200 text-gray-600 p-4 rounded-lg',
        DARK: 'bg-gray-800 border border-gray-700 text-gray-100 p-4 rounded-lg'
    },

    // Common Messages
    MESSAGES: {
        LOADING: 'Loading...',
        ERROR: 'An error occurred. Please try again.',
        SUCCESS: 'Operation completed successfully!',
        NO_DATA: 'No data available.',
        SAVE_SUCCESS: 'Saved successfully!',
        DELETE_SUCCESS: 'Deleted successfully!',
        DELETE_CONFIRM: 'Are you sure you want to delete this item?',
        UNSAVED_CHANGES: 'You have unsaved changes. Are you sure you want to leave?'
    },

    // Validation Messages
    VALIDATION: {
        REQUIRED: 'This field is required',
        EMAIL_INVALID: 'Please enter a valid email address',
        PASSWORD_MIN_LENGTH: 'Password must be at least 6 characters',
        PASSWORDS_DONT_MATCH: 'Passwords do not match',
        DUPLICATE_ENTRY: 'This entry already exists',
        INVALID_FORMAT: 'Invalid format'
    },

    // File Upload
    FILE_UPLOAD: {
        MAX_SIZE_MB: 10,
        ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
        ALLOWED_AUDIO_TYPES: ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/mp4'],
        ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/webm', 'video/ogg']
    },

    // Navigation Actions
    NAVIGATION_ACTIONS: {
        NEXT_LEVEL: 'nextLevel',
        BACK: 'back',
        COMPLETE: 'complete',
        RETRY: 'retry'
    },

    // Activity Configuration - Maps each activity type to its levels and component paths
    ACTIVITY_CONFIG: {
        WORD_MEANING: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study word meanings and pronunciations',
                    icon: '📚',
                    component: 'wordMeaning/WordMeaningLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: English Meanings',
                    description: 'Type in English meanings of the words',
                    icon: '✍🏼',
                    component: 'activityType/EnglishWordValidator',
                    props: {
                        activityType: 'WORD_MEANING',
                        title: 'Word Meaning - Type English Meaning'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Multiple Choice',
                    description: 'Choose correct word from options',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'WORD_MEANING_MCQ',
                        title: 'Word Meaning - Select the Meaning',
                        questionLabel: 'Select the correct Kannada meaning for this English word'
                    }
                },
                {
                    id: 4,
                    title: 'Level 4: Letter Arrangement',
                    description: 'Arrange letters and practice spellings',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'WORD_MEANING'
                    }
                }
            ]
        },
        FILL_IN_BLANK_MCQ: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study the sentences and answers',
                    icon: '📚',
                    component: 'fillInBlank/FillInBlankLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Multiple Choice',
                    description: 'Choose the correct word for the blank',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'FILL_IN_BLANK_MCQ'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters to form the correct answer',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'FILL_IN_BLANK_MCQ'
                    }
                }
            ]
        },
        DUAL_MEANING: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study dual-meaning words and pronunciations',
                    icon: '📚',
                    component: 'dualMeaning/DualMeaningLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: English Word',
                    description: 'Type the English word for the dual-meaning Kannada word',
                    icon: '✍🏼',
                    component: 'activityType/EnglishWordValidator',
                    props: {
                        activityType: 'DUAL_MEANING',
                        title: 'Dual Meaning - Type English Word'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Multiple Choice',
                    description: 'Choose correct meaning from options',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'DUAL_MEANING_MCQ',
                        title: 'Dual Meaning - Select the Meaning',
                        questionLabel: 'Select the correct Kannada meaning for this English word'
                    }
                },
                {
                    id: 4,
                    title: 'Level 4: Letter Arrangement',
                    description: 'Arrange letters and practice spellings for each meaning',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'DUAL_MEANING'
                    }
                }
            ]
        },
        MATCH: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Match the Following',
                    description: 'Connect related Language words by matching pairs',
                    icon: '🔗',
                    difficulty: 'Easy',
                    component: 'match/MatchLevel1Page'
                }
            ]
        },
        OPPOSITES: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learn Opposites',
                    description: 'Match words with their opposites',
                    icon: '↔️',
                    difficulty: 'Easy',
                    component: 'opposites/OppositesLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Fill Opposites',
                    description: 'Complete sentences with opposite words',
                    icon: '📝',
                    difficulty: 'Medium',
                    component: 'opposites/OppositesLevel2Page'
                },
                {
                    id: 3,
                    title: 'Level 3: Opposite Challenge',
                    description: 'Advanced opposite word matching',
                    icon: '🎯',
                    difficulty: 'Hard',
                    component: 'opposites/OppositesLevel3Page'
                }
            ]
        },
        WHO_SAID_TO_WHOM: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn who said what to whom',
                    icon: '📚',
                    component: 'whoSaidToWhom/WhoSaidToWhomLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Multiple Choice',
                    description: 'Choose correct option',
                    icon: '✅',
                    component: 'whoSaidToWhom/WhoSaidToWhomLevel2Page'
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters and practice spellings',
                    icon: '🧩',
                    component: 'whoSaidToWhom/WhoSaidToWhomLevel3Page'
                }
            ]
        },
        QUESTION_ANSWERS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study question and answers',
                    icon: '📚',
                    difficulty: 'Learning',
                    component: 'questionAnswer/QuestionAnswerLevel1'
                },
                {
                    id: 2,
                    title: 'Level 2: Word Selection',
                    description: 'Build answers using words',
                    icon: '📝',
                    difficulty: 'Easy',
                    component: 'activityType/SentenceValidatorGame',
                    props: {
                        activityType: 'QUESTION_ANSWERS'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters and practice spellings',
                    icon: '🧩',
                    difficulty: 'Hard',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'QUESTION_ANSWERS'
                    }
                }
            ]
        },
        LONG_QUESTION_ANSWERS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    icon: '📚',
                    difficulty: 'Learning',
                    component: 'longQuestionAnswer/LongQuestionAnswerLevel1'
                },
                {
                    id: 2,
                    title: 'Level 2: Learn Keywords',
                    icon: '📖',
                    difficulty: 'Easy',
                    component: 'longQuestionAnswer/LongQuestionAnswerLevel2'
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    icon: '🧩',
                    difficulty: 'Hard',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'LONG_QUESTION_ANSWERS'
                    }
                },
                {
                    id: 4,
                    title: 'Level 4: Fill Paragraph',
                    icon: '📝',
                    difficulty: 'Hard',
                    component: 'activityType/FillInBlanksParagraph',
                    props: {
                        activityType: 'LONG_QUESTION_ANSWERS'
                    }
                },
                {
                    id: 5,
                    title: 'Level 5: Arrange Sentences',
                    icon: '🔀',
                    difficulty: 'Expert',
                    component: 'activityType/SentenceValidatorGame',
                    props: {
                        activityType: 'LONG_QUESTION_ANSWERS'
                    }
                }
            ]
        },
        WORD_PRACTICE: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    icon: '📚',
                    component: 'wordPractice/WordPracticeLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Multiple Choice',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'WORD_PRACTICE_MCQ',
                        title: 'Word Practice - Select the Word',
                        questionLabel: 'Select the correct Kannada word for this English word'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'WORD_PRACTICE'
                    }
                }
            ]
        },
        WORD_SPLIT: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    icon: '📚',
                    component: 'wordSplit/WordSplitActivityPage'
                },
                {
                    id: 2,
                    title: 'Level 2: Letter Arrangement',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'WORD_SPLIT'
                    }
                }
            ]
        },
        JOIN_WORDS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Study words and their combinations',
                    icon: '📚',
                    component: 'joinWords/JoinWordsLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Multiple Choice',
                    description: 'Choose the correct combined word',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'JOIN_WORDS_MCQ',
                        title: 'Join Words - Select the Combined Word'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters to form the joined word',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'JOIN_WORDS'
                    }
                }
            ]
        },
        GENDERS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    icon: '⚧',
                    description: 'Learn words with their genders',
                    component: 'genders/GendersLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Choose the Gender',
                    icon: '✅',
                    description: 'Select the correct gender for the word',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'GENDERS_MCQ',
                        title: 'Genders - Select the Gender',
                        questionLabel: 'Select the correct gender for this word'
                    }
                }
            ]
        },
        CREATIVE_WRITING: {
            hasLevels: false,
            component: 'creativeWriting/CreativeWritingActivityPage'
        },
        NUMBERS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn numbers in English and the target language',
                    icon: '🔢',
                    component: 'numbers/NumbersLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Match the Number',
                    description: 'Select the correct language number for the English number',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'NUMBERS_MCQ',
                        title: 'Numbers - Match the Number',
                        questionLabel: 'Select the correct language number for this English number'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Match the Word',
                    description: 'Select the correct language word for this number',
                    icon: '🧠',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'NUMBERS_WORD_MCQ',
                        title: 'Numbers - Match the Word',
                        questionLabel: 'Select the correct language word for this number'
                    }
                },
                {
                    id: 4,
                    title: 'Level 4: Build the Word',
                    description: 'Arrange letters to form the language word for the number',
                    icon: '🔤',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'NUMBERS'
                    }
                }
            ]
        },
        CHANGE_GENDERS: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn male and female gender forms with images and audio',
                    icon: '⚧',
                    component: 'changeGenders/ChangeGendersLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Change the Gender',
                    description: 'Choose the correct opposite gender word',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'CHANGE_GENDERS_MCQ',
                        title: 'Change Genders - Multiple Choice',
                        questionLabel: 'Select the correct opposite gender word'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Letter Arrangement',
                    description: 'Arrange letters to form the opposite gender word',
                    icon: '🧩',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'CHANGE_GENDERS'
                    }
                }
            ]
        },
        TENSES: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn example sentences for each tense',
                    icon: '📚',
                    component: 'tenses/TensesLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Identify the Tense',
                    description: 'Read the Kannada sentence and choose its tense',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'TENSES_MCQ',
                        title: 'Tenses - Choose the Tense',
                        questionLabel: 'Select the correct tense for this Kannada sentence'
                    }
                },
                {
                    id: 3,
                    title: 'Level 3: Build the Sentence',
                    description: 'See the English sentence and build the language sentence',
                    icon: '🧩',
                    component: 'activityType/SentenceValidatorGame',
                    props: {
                        activityType: 'TENSES_SENTENCE'
                    }
                }
            ]
        },
        SINGULAR_PLURAL: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn singular and plural forms in Kannada and English',
                    icon: '🔁',
                    component: 'singularPlural/SingularPluralLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Choose Singular / Plural',
                    description: 'Read the Kannada word and choose whether it is singular or plural',
                    icon: '✅',
                    component: 'activityType/MultipleChoiceValidator',
                    props: {
                        activityType: 'SINGULAR_PLURAL_MCQ',
                        title: 'Singular / Plural - Select the Form',
                        questionLabel: 'ಈ ಪದ ಏಕವಚನದಾ ಅಥವಾ ಬಹುವಚನದಾ?'
                    }
                }
            ]
        },
        MAKE_SENTENCES: {
            hasLevels: true,
            levels: [
                {
                    id: 1,
                    title: 'Level 1: Learning Mode',
                    description: 'Learn words and sentences with images and audio',
                    icon: '📚',
                    component: 'makeSentences/MakeSentencesLevel1Page'
                },
                {
                    id: 2,
                    title: 'Level 2: Learn Keywords',
                    icon: '📖',
                    difficulty: 'Easy',
                    component: 'longQuestionAnswer/LongQuestionAnswerLevel2'
                },
                {
                    id: 3,
                    title: 'Level 3: Practice Words',
                    icon: '✍️',
                    difficulty: 'Medium',
                    component: 'activityType/EnglishWordValidator',
                    props: {
                        activityType: 'MAKE_SENTENCES',
                        title: 'Make Sentences - Type English Keywords'
                    }
                },
                {
                    id: 4,
                    title: 'Level 4: Letter Arrangement',
                    icon: '🧩',
                    difficulty: 'Hard',
                    component: 'activityType/LetterArrangementGame',
                    props: {
                        activityType: 'MAKE_SENTENCES'
                    }
                },
                {
                    id: 5,
                    title: 'Level 5: Arrange Sentences',
                    icon: '🔀',
                    difficulty: 'Expert',
                    component: 'activityType/SentenceValidatorGame',
                    props: {
                        activityType: 'MAKE_SENTENCES'
                    }
                }
            ]
        }
    },

    // Results Configuration - Maps each activity type to its results display component
    RESULTS_CONFIG: {
        // Standard results using ResultsDisplayer with default rendering
        STANDARD: {
            component: 'ResultsDisplayer',
            type: 'standard'
        },
        // Match activity has custom results display
        MATCH: {
            component: 'MatchResults',
            type: 'custom'
        },
        // Opposites activity has custom results display
        OPPOSITES: {
            component: 'OppositesResults',
            type: 'custom'
        },
        // Who Said To Whom has custom results display
        WHO_SAID_TO_WHOM: {
            component: 'WhoSaidToWhomResults',
            type: 'custom'
        }
    },

    // Backward compatibility - Map old constants to new ACTIVITY_CONFIG
    // These are deprecated but kept for backward compatibility
    get WORD_MEANING_LEVELS() {
        return this.ACTIVITY_CONFIG.WORD_MEANING.levels;
    },
    get MATCH_LEVELS() {
        return this.ACTIVITY_CONFIG.MATCH.levels;
    },
    get OPPOSITES_LEVELS() {
        return this.ACTIVITY_CONFIG.OPPOSITES.levels;
    },
    get WHO_SAID_TO_WHOM_LEVELS() {
        return this.ACTIVITY_CONFIG.WHO_SAID_TO_WHOM.levels;
    },
    get QUESTION_ANSWERS_LEVELS() {
        return this.ACTIVITY_CONFIG.QUESTION_ANSWERS.levels;
    },
    get LONG_QUESTION_ANSWERS_LEVELS() {
        return this.ACTIVITY_CONFIG.LONG_QUESTION_ANSWERS.levels;
    },
    get WORD_PRACTICE_LEVELS() {
        return this.ACTIVITY_CONFIG.WORD_PRACTICE.levels;
    }
};

export default Constants;